/*
 payments/payments/result_after_single_call
 */

import actions from '../../common/lib/utils/actions.js';
import constants from '../../common/lib/utils/constants.js';
import dataflow from '../../common/lib/dataflow.js';

const register = dataflow.register;
const state = {
	paymentmethods: null, // see structure in 'paymentmethods.js'
	paymentResultData: null
};

function registerActions() {
	function resultAfterSingleCall(payload) {
		let accHistRef;

		let paymentFetchResultFlow;
		let paymentHandled;
		if (payload.type === constants.PAYMENTMETHODS) {
			state.paymentmethods = payload.data;
		}

		if (payload.type === constants.SUBMIT_PAYMENT) {
			if (payload && payload.sendHandlerType === constants.RESULT_AFTER_SINGLE_CALL) {
				// sendHandlerData = payload.sendHandlerData;
				accHistRef = payload.accHistRef;
				paymentFetchResultFlow = payload.paymentFetchResultFlow;
				paymentHandled = {
					fetch_type: constants.FETCH_TYPE_SYNCH,
					accHistRef,
					paymentFetchResultFlow
				};
				// actions.paymentHandled(paymentHandled);
				actions.resultAfterSingleCall(paymentHandled);
			}
		}
	}
	register(resultAfterSingleCall);
}

export default {
	init() {
		registerActions();
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/result-after-single-call.js